import styled from '@emotion/styled'
import { graphql } from 'gatsby'
import React, { useState, useEffect } from 'react'
import Link from '../Link/index'
import klavyioSignUp from '../../lib/klavyio'
import { trackSignUp } from '../../lib/ga4'
import { useShopStoreIncontext } from '../../context/shopContext'
import aus from './LocalisationSelector/flags/aus.svg'
import eu from './LocalisationSelector/flags/eu.svg'
import usa from './LocalisationSelector/flags/usa.svg'
import uk from './LocalisationSelector/flags/uk.svg'
import nz from './LocalisationSelector/flags/nz.svg'
import ca from './LocalisationSelector/flags/ca.svg'

import ChevronRight from '../../images/storybook-images/panelsV2/footer/chevron-right.svg'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import FooterV2 from './v2/footer'

const FooterContainer = styled.div`
  background-color: #212121;
  position: relative;
  z-index: 999;
  @media (max-width: 768px) {
    width: 100%;
  }
`
const BottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: base-line;
  margin-bottom: 8px;
  @media (min-width: 769px) {
    margin: 24px 48px;
  }
  @media (max-width: 768px) {
    margin: 40px;
  }
`
const FlagLeft = styled.div`
  padding: 8px;
`
const Terms = styled.div`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: -0.26px;
  color: #FFFFFF80;
  display: flex;
  align-items: center;
`
const Sitemap = styled.div`
  @media (min-width: 769px) {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }
`
const SitemapLinks = styled.div`
  padding: 48px;
  padding-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media (min-width: 769px) {
    width: 50%;
    justify-content: flex-end;
  }
  @media (max-width: 768px) {
    padding: 40px;
    padding-bottom: 8px;
    justify-content: flex-start;
    padding: 0px 24px;
  }
  opacity: 1;
  font-family: Objectivity;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: -0.44px;
  color: rgb(var(--very-light-pink));
`
const SitemapSocials = styled.div`
  padding: 48px;
  padding-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media (min-width: 769px) {
    width: 50%;
    justify-content: flex-end;
  }
  @media (max-width: 768px) {
    padding: 40px;
    padding-bottom: 8px;
    justify-content: flex-start;
  }
  opacity: 1;
  font-family: Objectivity;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: -0.44px;
  color: rgb(var(--very-light-pink));
`
const SitemapHeading = styled.div`
  padding: 48px;
  padding-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media (min-width: 769px) {
    width: 50%;
    justify-content: flex-start;
  }
  @media (max-width: 768px) {
    padding: 40px;
    padding-bottom: 8px;
    justify-content: flex-start;
  }
  opacity: 1;
  font-family: Objectivity;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: -0.44px;
  color: rgb(var(--very-light-pink));
`
const Column = styled.div`
  padding: 8px 16px;
  margin-left: 0;
  padding-bottom: 0;
  width: 145px;
`
const SitmapHeading = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 2.09;
  letter-spacing: 0.23px;
  color: #FFFFFF;
  text-transform: uppercase;
`
const StyledExternalLink = styled(Link)`
  position: relative;
  display: inline-block;
  color: white;
  text-decoration: none;
  font-size: 11px;
  line-height: 24px;
  z-index: 10;
  &:hover {
    color: white;
  }
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 1px;
    bottom: 6px;
    left: 0;
    background-color: #ffffff;
    transform-origin: bottom right;
    transition: transform 0.25s ease-out;
    z-index: 5;
  }
  &:hover::before {
    transform: scaleX(1);
    transform-origin: bottom left;
  }
`
const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
`
const SignupSection = styled.div`
  background-color: rgb(var(--very-light-pink));
  display: flex;
  align-items: stretch;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`
const SignupContent = styled.div`
width: 100%;
display: flex;
flex-direction: column;
  @media (max-width: 768px) {
    display: none;
  }
  @media (min-width: 769px) {
    text-align: center;
    font-size: 16px;
  }
`

const IconImageGatsby = styled(GatsbyImage)`
  height: 20px;
  width: 20px;
  margin: 15px auto;
`

const SignupContentMobile = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 40px;
  @media (min-width: 769px) {
    display: none;
  }
`
const SignupSubHeading = styled.div`
  font-size: 11px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.91;
  letter-spacing: 0.23px;
  margin-bottom: 12px;
  color: #ffffff;
  @media (max-width: 768px) {
    margin-bottom: 0;
  }
`
const SignupHeading = styled.div`
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.2px;
  color: #ffffff;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`
const TransparentButton = styled.div`
  border-radius: 27px;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.45px;
  text-align: center;
  background: transparent;
  height: 48px;
  padding: 0 16px;
  outline: none;
  color: #000000;
  justify-content: center;
  align-items: center;
  display: flex;
  @media (max-width: 768px) {
    height: 36px;
    color: white;
  }
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background-color: rgba(grey, 0.2);
    color: black;
    border-color: white;
  }
  &:hover {
    background-color: rgba(grey, 1);
    color: black;
    border-color: white;
  }
`
const EmailButtonContainer = styled.div`
  display: flex;
  margin: 16px 0;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`
const TextInputContainer = styled.div`
  background-color: #FFFFFF33;
  padding: 8px;
  display: flex;
  justify-content: stretch;
  align-items: center;
  flex-grow: 1;
  border-radius: 50px;
  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 16px;
  }
`
const TextInput = styled.input`
  font-size: 24px;
  font-family: Objectivity;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  background-color: transparent;
  border: none;
  outline: none;
  width: calc(100% - 16px);
  margin-left: 20px;
  color: white;
  font-weight: 500;
  @media (max-width: 768px) {
    text-align: center;
    font-size: 16px;
  }
  ::placeholder {
    color: white; // Set the placeholder text color to white
    opacity: 1; // You can adjust the opacity if needed
  }
`
const MediaIcons = styled.div`
display: flex;
justify-content: end;
align-items: center;
@media (max-width: 768px) {
  padding: 0;
  margin-left: 0px;
}
`
const IconLogo = styled(GatsbyImage)`
  height: 70px;
  width: 155px;
  @media (max-width: 1025px) {
    margin: 20px 0;
  }
`
const IconCircle = styled.div`
width: 50px;
height: 50px;
background-color: white;
border-radius: 50%;
margin-right: 10px;  /* Add this line to add spacing between icons */
`
const useFooterData = (data) => {
  const { strapiFooter, strapiShared } = data

  return {
    strapiFooter,
    strapiShared
  }
}

const Footer = ({ data, sliceContext }) => {
  const { strapiFooter, strapiShared } = useFooterData(data)
  const socials = [
    {
      ImageSrc: data.facebookImg,
      link: 'https://facebook.com/july'
    },
    {
      ImageSrc: data.instagramImg,
      link: 'https://instagram.com/july'
    },
    {
      ImageSrc: data.tiktokImg,
      link: 'https://www.tiktok.com/@july'
    },
    {
      ImageSrc: data.pinterestImg,
      link: 'https://pinterest.com/july'
    },
  ]

  let [email, setEmail] = useState('')
  let [sent, setSent] = useState(false)
  let [emailValid, setEmailValid] = useState(true)
  let [phoneValid, setPhoneValid] = useState(true)
  let [isPhone, setIsPhone] = useState(false)

  const { footerRef, setLocationSelectorOpen, region } = useShopStoreIncontext(
    (state) => {
      return {
        footerRef: state.footerRef,
        setLocationSelectorOpen: state.actions.setLocationSelectorOpen,
        region: state.region,
      }
    }
  )
  const storeLocale = sliceContext.locale
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    setLoaded(prev => !prev)
  }, [storeLocale])

  const flagLookup = {
    'en-AU': aus,
    'en': usa,
    'en-NZ': nz,
    'en-GB': uk,
    'en-CA': ca,
  };

  // Determine the correct flag based on locale and region
  const getCurrentFlag = () => {
    if (storeLocale === 'en-GB' && region === 'eu') {
      return eu;
    }
    return flagLookup[storeLocale];
  };

  const handleChange = (e) => {
    setEmail(e.target.value)
    if (!emailValid) {
      validateEmail(e.target.value)
    }
    if (!phoneValid) {
      validatePhone(e.target.value)
    }

    const regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    if (e.target.value.length > 0 && !regex.test(e.target.value)) {
      setIsPhone(false)
      return false
    } else {
      setIsPhone(true)
    }
  }

  const handleEnter = async () => {
    if (validateEmail(email) || validatePhone(email)) {
      await klavyioSignUp({
        ...(isPhone ? {
          phone_number: email
        } : {
          email
        }),
        signupID: strapiShared.SignUpId,
        source: 'Signup Footer'
      })
      trackSignUp({ method: email.includes('@') ? 'email' : 'phone' })
      setEmail('')
      setSent(true)
    }
  }
  const add = (event) => {
    if (event.keyCode === 13) {
      handleEnter()
    }
  }
  const validateEmail = (value) => {
    const regex =
      /^(?=(.{1,64}@.{1,255}))([!#$%&'*+\-\/=?\^_`{|}~a-zA-Z0-9}]{1,64}(\.[!#$%&'*+\-\/=?\^_`{|}~a-zA-Z0-9]{0,}){0,})@((\[(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}\])|([a-zA-Z0-9-]{1,63}(\.[a-zA-Z0-9-]{2,63}){1,}))$/ // eslint-disable-line
    if (value.length >= 0 && !regex.test(value)) {
      setEmailValid(false)
      return false
    }
    setEmailValid(true)
    return true
  }
  const validatePhone = (value) => {
    const regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    if (value.length >= 0 && !regex.test(value)) {
      setPhoneValid(false)
      setIsPhone(false)
      return false
    }
    setPhoneValid(true)
    setIsPhone(true)
    return true
  }

  const placeholderSignUp =
    storeLocale === 'en' ? 'your@email.com or +11234567890' :
      storeLocale === 'en-AU' ? 'your@email.com or +61412345678' :
        storeLocale === 'en-NZ' ? 'your@email.com or +64412345678' :
          'your@email.com or +4412345678';

  const [currentYear] = useState(new Date().getFullYear())
  return (
    <>
      {/* <FooterV2 sliceContext={sliceContext} data={data} strapiFooter={strapiFooter} strapiShared={strapiShared}/> */}
      <footer ref={footerRef}>
        <FooterContainer>
          <FooterContent>
            <Sitemap>
              <SitemapHeading>
                <SignupHeading>
                  <div dangerouslySetInnerHTML={{ __html: strapiFooter?.TagLine }} />
                </SignupHeading>
              </SitemapHeading>
              <SignupContentMobile>
                {
                  isPhone && (
                    <SignupSubHeading>
                      By submitting this form and signing up for texts, you consent to receive marketing text messages (e.g. promos, cart reminders) from July at the number provided, including messages sent by autodialer. Consent is not a condition of purchase. Msg & data rates may apply. Msg frequency varies. Unsubscribe at any time by replying STOP or clicking the unsubscribe link (where available). <Link to="/privacy-policy/">Privacy Policy</Link> & <Link to="/terms-conditions/">Terms</Link>
                    </SignupSubHeading>
                  )
                }
                <EmailButtonContainer>
                  {sent ? (
                    <>
                      {' '}
                      <br /> Thanks for signing up{' '}
                    </>
                  ) : (
                    <>
                      <TextInputContainer>
                        <TextInput
                          value={email}
                          onKeyDown={add}
                          onChange={handleChange}
                          placeholder={placeholderSignUp}
                        />
                        <TransparentButton onClick={handleEnter}>
                          <img src={ChevronRight} alt={'ChevronRight'} />
                        </TransparentButton>
                      </TextInputContainer>

                    </>
                  )}
                </EmailButtonContainer>
                {
                  (!emailValid && !phoneValid) && (
                    <div
                      style={{
                        fontWeight: 600,
                        color: 'rgb(var(--terracota))',
                      }}
                    >
                      {'Email or Phone not vaild.'}
                    </div>
                  )
                }
              </SignupContentMobile>
              <SitemapLinks>
                {
                  strapiFooter?.FooterLinks.map((footerCategory, key) => {
                    return (
                      <Column key={key}>
                        <SitmapHeading> {footerCategory.CatgeoryName} </SitmapHeading>
                        {footerCategory.FooterLinks?.map((subItem, key2) =>
                          <React.Fragment key={key2}>
                            <StyledExternalLink to={subItem.to} key={`external-link-${key2}`}>
                              {subItem.text}
                            </StyledExternalLink>
                            <br />
                          </React.Fragment>
                        )}
                      </Column>
                    )
                  })
                }
              </SitemapLinks>
            </Sitemap>
            <Sitemap>
              <SitemapLinks style={{ paddingTop: 24 }}>
                <SignupContent>
                  {
                    isPhone && (
                      <SignupSubHeading>
                        By submitting this form and signing up for texts, you consent to receive marketing text messages (e.g. promos, cart reminders) from July at the number provided, including messages sent by autodialer. Consent is not a condition of purchase. Msg & data rates may apply. Msg frequency varies. Unsubscribe at any time by replying STOP or clicking the unsubscribe link (where available). <Link to="/privacy-policy/">Privacy Policy</Link> & <Link to="/terms-conditions/">Terms</Link>
                      </SignupSubHeading>
                    )
                  }
                  <EmailButtonContainer>
                    {sent ? (
                      <>
                        {' '}
                        <br /> Thanks for signing up{' '}
                      </>
                    ) : (
                      <>
                        <TextInputContainer>
                          <TextInput
                            value={email}
                            onKeyDown={add}
                            onChange={handleChange}
                            placeholder={placeholderSignUp}
                          />
                          <TransparentButton onClick={handleEnter}>
                            <img src={ChevronRight} alt={'ChevronRight'} />
                          </TransparentButton>
                        </TextInputContainer>

                      </>
                    )}
                  </EmailButtonContainer>
                  {
                    (!emailValid && !phoneValid) && (
                      <div
                        style={{
                          fontWeight: 600,
                          color: 'rgb(var(--terracota))',
                        }}
                      >
                        {'Email or Phone not vaild.'}
                      </div>
                    )
                  }
                </SignupContent>
              </SitemapLinks>
              <SitemapSocials style={{ paddingTop: 24 }}>
                {
                  storeLocale === 'en-AU' && (
                    <MediaIcons>
                      <IconLogo
                        image={getImage(
                          data.footerOlympicIcon?.childImageSharp?.gatsbyImageData
                        )}
                        alt={'Footer Olympic Logo'}
                      />
                    </MediaIcons>
                  )
                }
                <MediaIcons>
                  {
                    socials.map((image, key) => (
                      <IconCircle key={key}>
                        <Link to={image.link}>
                          <IconImageGatsby
                            image={getImage(
                              image.ImageSrc?.childImageSharp?.gatsbyImageData
                            )}
                            alt={image.link}
                          />
                        </Link>
                      </IconCircle>
                    ))
                  }
                  <img onClick={() => setLocationSelectorOpen(true)} src={getCurrentFlag()} alt="flag" style={{ height: 50, width: 50, padding: 0, backgroundColor: 'transparent', cursor: 'pointer' }} />
                </MediaIcons>
              </SitemapSocials>
            </Sitemap>
            <BottomContainer>
              <Terms>
                <div>
                  <span> You can withdraw your consent at any time. Read about how we process your personal data in our </span>
                  <Link
                    to="/privacy-policy/"
                    styles={{
                      fontSize: 11,
                      color: 'rgb(var(--very-light-pink))',
                      textDecoration: 'underline',
                    }}
                  >
                    Privacy Policy
                  </Link>
                </div>{' '}
              </Terms>
              <FlagLeft>
                <Terms>
                  <span> © July {currentYear} All Rights Reserved </span>
                </Terms>
              </FlagLeft>
            </BottomContainer>
          </FooterContent>
        </FooterContainer>
      </footer>
    </>
  )
}

export default Footer

export const query = graphql`
  query ($locale: String) {
    strapiShared(locale: {eq: $locale}) {
      locale
      SignUpId
    }
    strapiFooter(locale: {eq: $locale}) {
      locale
      EmailSignUpBody
      EmailSignupHeading
      EmailSignUpBanner {
        ...Image
      }
      TagLine
      FooterLinks {
        CatgeoryName
        FooterLinks {
          NewTab
          text
          to
        }
      }
    }
    facebookImg: file(relativePath: { eq: "assets/footer/facebook.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        gatsbyImageDataMobile: gatsbyImageData(quality: 85, placeholder: NONE, width: 550)
      }
    }
    instagramImg: file(relativePath: { eq: "assets/footer/instagram.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        gatsbyImageDataMobile: gatsbyImageData(quality: 85, placeholder: NONE, width: 550)
      }
    }
    pinterestImg: file(relativePath: { eq: "assets/footer/pinterest.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        gatsbyImageDataMobile: gatsbyImageData(quality: 85, placeholder: NONE, width: 550)
      }
    }
    tiktokImg: file(relativePath: { eq: "assets/footer/tiktok.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        gatsbyImageDataMobile: gatsbyImageData(quality: 85, placeholder: NONE, width: 550)
      }
    }
    footerOlympicIcon: file(relativePath: { eq: "assets/footer/footer-olympic-logo.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        gatsbyImageDataMobile: gatsbyImageData(quality: 85, placeholder: NONE, width: 550)
      }
    }
  }
`
